import { Action } from '@ngrx/store';
import { TechnicalError } from '@dch/products-business-logic';

export const GET_PRODUCT_DETAILS = 'GET_PRODUCT_DETAILS_DETAILS';
export const GET_PRODUCT_DETAILS_SUCCESS = 'GET_PRODUCT_DETAILS_SUCCESS';
export const GET_PRODUCT_DETAILS_SUCCESS_NO_CHANGE =
  'GET_PRODUCT_DETAILS_SUCCESS_NO_CHANGE';
export const GET_PRODUCT_DETAILS_FAILED = 'GET_PRODUCT_DETAILS_FAILED';
export const GET_PRODUCT_AVAILABLE_OPTIONS = 'GET_PRODUCT_AVAILABLE_OPTIONS';
export const GET_PRODUCT_AVAILABLE_OPTIONS_SUCCESS =
  'GET_PRODUCT_AVAILABLE_OPTIONS_SUCCESS';
export const GET_PRODUCT_AVAILABLE_OPTIONS_SUCCESS_NO_CHANGE =
  'GET_PRODUCT_AVAILABLE_OPTIONS_SUCCESS_NO_CHANGE';
export const GET_PRODUCT_AVAILABLE_OPTIONS_FAILED =
  'GET_PRODUCT_AVAILABLE_OPTIONS_FAILED';
export const GET_PRODUCT_AVAILABLE_SETTINGS = 'GET_PRODUCT_AVAILABLE_SETTINGS';
export const GET_PRODUCT_AVAILABLE_SETTINGS_SUCCESS =
  'GET_PRODUCT_AVAILABLE_SETTINGS_SUCCESS';
export const GET_PRODUCT_AVAILABLE_SETTINGS_SUCCESS_NO_CHANGE =
  'GET_PRODUCT_AVAILABLE_SETTINGS_SUCCESS_NO_CHANGE';
export const GET_PRODUCT_AVAILABLE_SETTINGS_FAILED =
  'GET_PRODUCT_AVAILABLE_SETTINGS_FAILED';
export const GET_PRODUCT_AVAILABLE_SUBSCRIPTIONS =
  'GET_PRODUCT_AVAILABLE_SUBSCRIPTIONS';
export const GET_PRODUCT_AVAILABLE_SUBSCRIPTIONS_SUCCESS =
  'GET_PRODUCT_AVAILABLE_SUBSCRIPTIONS_SUCCESS';
export const GET_PRODUCT_AVAILABLE_SUBSCRIPTIONS_SUCCESS_NO_CHANGE =
  'GET_PRODUCT_AVAILABLE_SUBSCRIPTIONS_SUCCESS_NO_CHANGE';
export const GET_PRODUCT_AVAILABLE_SUBSCRIPTIONS_FAILED =
  'GET_PRODUCT_AVAILABLE_SUBSCRIPTIONS_FAILED';
export const CLEAR_DELETE_MANDATE_FLAG = 'CLEAR_DELETE_MANDATE_FLAG';
export const DELETE_MANDATE = 'DELETE_MANDATE';
export const DELETE_MANDATE_SUCCESS = 'DELETE_MANDATE_SUCCESS';
export const DELETE_MANDATE_ERROR = 'DELETE_MANDATE_ERROR';
export const GET_DEEP_LINK_OPTION_DETAILS = 'GET_DEEP_LINK_OPTION_DETAILS';
export const GET_DEEP_LINK_OPTION_DETAILS_SUCCESS =
  'GET_DEEP_LINK_OPTION_DETAILS_SUCCESS';
export const GET_DEEP_LINK_OPTION_DETAILS_SUCCESS_NO_CHANGE =
  'GET_DEEP_LINK_OPTION_DETAILS_SUCCESS_NO_CHANGE';
export const GET_DEEP_LINK_OPTION_DETAILS_FAILED = 'GET_OPTION_DETAILS_FAILED';
export const GET_OPTION_DETAILS = 'GET_OPTION_DETAILS';
export const GET_OPTION_DETAILS_SUCCESS = 'GET_OPTION_DETAILS_SUCCESS';
export const GET_OPTION_DETAILS_SUCCESS_NO_CHANGE =
  'GET_OPTION_DETAILS_SUCCESS_NO_CHANGE';
export const GET_OPTION_DETAILS_FAILED = 'GET_OPTION_DETAILS_FAILED';
export const GET_EBU_PRODUCT_DETAILS = 'GET_EBU_PRODUCT_DETAILS_DETAILS';
export const GET_EBU_PRODUCT_DETAILS_SUCCESS =
  'GET_EBU_PRODUCT_DETAILS_SUCCESS';
export const GET_EBU_PRODUCT_DETAILS_SUCCESS_NO_CHANGE =
  'GET_EBU_PRODUCT_DETAILS_SUCCESS_NO_CHANGE';
export const GET_EBU_PRODUCT_DETAILS_FAILED = 'GET_EBU_PRODUCT_DETAILS_FAILED';
export const UPDATE_EBU_ACTIVE_OPTIONS = 'UPDATE_EBU_ACTIVE_OPTIONS';
export const UPDATE_EBU_ACTIVE_OPTIONS_SUCCESS =
  'UPDATE_EBU_ACTIVE_OPTIONS_SUCCESS';

export class GetProductDetails implements Action {
  type = GET_PRODUCT_DETAILS;

  constructor(public payload: any) {}
}

export class GetProductDetailsSuccess implements Action {
  type = GET_PRODUCT_DETAILS_SUCCESS;

  constructor(public payload: any) {}
}

export class GetProductDetailsSuccessNoChange implements Action {
  type = GET_PRODUCT_DETAILS_SUCCESS_NO_CHANGE;

  constructor(public payload?: any) {}
}

export class GetProductDetailsFailed implements Action {
  type = GET_PRODUCT_DETAILS_FAILED;

  constructor(public payload: TechnicalError) {}
}

export class GetProductAvailableOptions implements Action {
  type = GET_PRODUCT_AVAILABLE_OPTIONS;

  constructor(public payload: any) {}
}

export class GetProductAvailableOptionsSuccess implements Action {
  type = GET_PRODUCT_AVAILABLE_OPTIONS_SUCCESS;

  constructor(public payload: any) {}
}

export class GetProductAvailableOptionsSuccessNoChange implements Action {
  type = GET_PRODUCT_AVAILABLE_OPTIONS_SUCCESS_NO_CHANGE;

  constructor(public payload?: any) {}
}

export class GetProductAvailableOptionsFailed implements Action {
  type = GET_PRODUCT_AVAILABLE_OPTIONS_FAILED;

  constructor(public payload: TechnicalError) {}
}

export class GetProductAvailableSettings implements Action {
  type = GET_PRODUCT_AVAILABLE_SETTINGS;

  constructor(public payload: any) {}
}

export class GetProductAvailableSettingsSuccess implements Action {
  type = GET_PRODUCT_AVAILABLE_SETTINGS_SUCCESS;

  constructor(public payload: any) {}
}

export class GetProductAvailableSettingsSuccessNoChange implements Action {
  type = GET_PRODUCT_AVAILABLE_SETTINGS_SUCCESS_NO_CHANGE;

  constructor(public payload?: any) {}
}

export class GetProductAvailableSettingsFailed implements Action {
  type = GET_PRODUCT_AVAILABLE_SETTINGS_FAILED;

  constructor(public payload: TechnicalError) {}
}

export class GetProductAvailableSubscriptions implements Action {
  type = GET_PRODUCT_AVAILABLE_SUBSCRIPTIONS;

  constructor(public payload: any) {}
}

export class GetProductAvailableSubscriptionsSuccess implements Action {
  type = GET_PRODUCT_AVAILABLE_SUBSCRIPTIONS_SUCCESS;

  constructor(public payload: any) {}
}

export class GetProductAvailableSubscriptionsSuccessNoChange implements Action {
  type = GET_PRODUCT_AVAILABLE_SUBSCRIPTIONS_SUCCESS_NO_CHANGE;

  constructor(public payload?: any) {}
}

export class GetProductAvailableSubscripionsFailed implements Action {
  type = GET_PRODUCT_AVAILABLE_SUBSCRIPTIONS_FAILED;

  constructor(public payload: TechnicalError) {}
}

export class ClearDeleteMandateFlag implements Action {
  type = CLEAR_DELETE_MANDATE_FLAG;

  constructor(public payload?: any) {}
}

export class DeleteMandateSuccess implements Action {
  type = DELETE_MANDATE_SUCCESS;

  constructor(public payload: any) {}
}

export class DeleteMandate implements Action {
  type = DELETE_MANDATE;

  constructor(public payload: any) {}
}

export class DeleteMandateError implements Action {
  type = DELETE_MANDATE_ERROR;

  constructor(public payload?: any) {}
}

export class GetDeepLinkOptionDetails implements Action {
  type = GET_DEEP_LINK_OPTION_DETAILS;

  constructor(public payload?: string) {}
}

export class GetDeepLinkOptionDetailsSuccess implements Action {
  type = GET_DEEP_LINK_OPTION_DETAILS_SUCCESS;

  constructor(public payload: any) {}
}

export class GetDeepLinkOptionDetailsSuccessNoChange implements Action {
  type = GET_DEEP_LINK_OPTION_DETAILS_SUCCESS_NO_CHANGE;

  constructor(public payload?: any) {}
}

export class GetDeepLinkOptionDetailsFailed implements Action {
  type = GET_DEEP_LINK_OPTION_DETAILS_FAILED;

  constructor(public payload: any) {}
}

export class GetOptionDetails implements Action {
  type = GET_OPTION_DETAILS;

  constructor(public payload?: any) {}
}

export class GetOptionDetailsSuccess implements Action {
  type = GET_OPTION_DETAILS_SUCCESS;

  constructor(public payload: any) {}
}

export class GetOptionDetailsSuccessNoChange implements Action {
  type = GET_OPTION_DETAILS_SUCCESS_NO_CHANGE;

  constructor(public payload?: any) {}
}

export class GetOptionDetailsFailed implements Action {
  type = GET_OPTION_DETAILS_FAILED;

  constructor(public payload: any) {}
}

export class GetEBUProductDetails implements Action {
  type = GET_EBU_PRODUCT_DETAILS;

  constructor(public payload: any) {}
}

export class GetEBUProductDetailsSuccess implements Action {
  type = GET_EBU_PRODUCT_DETAILS_SUCCESS;

  constructor(public payload: any) {}
}

export class GetEBUProductDetailsSuccessNoChange implements Action {
  type = GET_EBU_PRODUCT_DETAILS_SUCCESS_NO_CHANGE;

  constructor(public payload?: any) {}
}

export class GetEBUProductDetailsFailed implements Action {
  type = GET_EBU_PRODUCT_DETAILS_FAILED;

  constructor(public payload: TechnicalError) {}
}

export class UpdateEBUOptionActiveStatus implements Action {
  type = UPDATE_EBU_ACTIVE_OPTIONS;

  constructor(public payload: any) {}
}

export class UpdateEBUOptionActiveStatusSuccess implements Action {
  type = UPDATE_EBU_ACTIVE_OPTIONS_SUCCESS;

  constructor(public payload: any) {}
}

export type Actions =
  | GetProductDetails
  | GetProductDetailsSuccess
  | GetProductDetailsSuccessNoChange
  | GetProductDetailsFailed
  | GetProductAvailableOptions
  | GetProductAvailableOptionsSuccess
  | GetProductAvailableOptionsSuccessNoChange
  | GetProductAvailableOptionsFailed
  | GetProductAvailableSettings
  | GetProductAvailableSettingsSuccess
  | GetProductAvailableSettingsSuccessNoChange
  | GetProductAvailableSettingsFailed
  | GetProductAvailableSubscriptions
  | GetProductAvailableSubscriptionsSuccess
  | GetProductAvailableSubscriptionsSuccessNoChange
  | GetProductAvailableSubscripionsFailed
  | ClearDeleteMandateFlag
  | DeleteMandateSuccess
  | DeleteMandate
  | DeleteMandateError
  | GetDeepLinkOptionDetails
  | GetDeepLinkOptionDetailsSuccess
  | GetDeepLinkOptionDetailsSuccessNoChange
  | GetDeepLinkOptionDetailsFailed
  | GetEBUProductDetails
  | GetEBUProductDetailsSuccess
  | GetEBUProductDetailsFailed
  | GetEBUProductDetailsSuccessNoChange
  | UpdateEBUOptionActiveStatus
  | UpdateEBUOptionActiveStatusSuccess;
